// extracted by mini-css-extract-plugin
export default {"blockedModalView":"BlockedModalView_blockedModalView__x2m-E"};